import React from "react";
import List from "../components/List";
import hipladeTemplate from "../../common/template";

function InterviewList() {
  return <List />;
}

export default hipladeTemplate(InterviewList);
